const moment = require('moment');
window.moment = moment;
